export default __webpack_public_path__ + "static/media/BalancedIcon.d2c7afc5.svg";